<template>
  <b-navbar
    toggleable="lg"
    class="p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm"
    variant="dark"
    type="none"
  >
    <b-navbar-brand :to="linkLogo">
      <img class="my-0 mr-md-auto" v-if="!imageError" @error="imageLoadOnError" :src="pathLogo" width="110" />
      <i class="my-0 mr-md-auto material-icons" v-else >
        perm_identity
      </i>
      <small class="d-block"
        >{{ $tc("label.versao") }}: {{ versao }} |
        {{ $tc("label.data_ultimo_acesso") }}: {{ data }}</small
      >
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse is-nav id="collapse">
      <b-navbar-nav>
        <b-nav-item-dropdown toggle-class="dropdown-user" right>
          <template v-slot:button-content class="sr-only">
            <img
              :src="pathFoto"
              alt="..."
              class="rounded-circle float-left"
              width="36"
              height="36"
            />
            <div class="d-inline-block ml-2">
              <div>{{ $t("label.bem_vindo") }}</div>
              <div>{{ nomeUsuario }}</div>
            </div>
            <span class="sr-only">(current)</span>
          </template>
          <b-dropdown-item  @click="onEditarPerfil">{{ $t("label.editar_perfil") }}</b-dropdown-item>
          <b-dropdown-item @click="onSair">{{ $t("label.sair") }}</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown v-if="exibeAcoes" toggle-class="mt-1" right>
          <template v-slot:button-content>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
              />
            </svg>
          </template>
          <b-dropdown-item
            v-bind:key="item.id"
            v-for="item in menuAcoes"
            :to="item.to"
          >
            {{ $t(item.texto) }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
  import moment from 'moment'
export default {
  /**
   * Header padrão da hCentrix
   */
  name: "HcHeader",
  props: {
    /**
     * Versão
     */
    versao: {
      type: String
    },
    /**
     * Data do Ultimo Acesso
     */
    dataUltimoAcesso: {
      type: Date
    },
    /**
     * Nome do usuário
     */
    nomeUsuario: {
      type: String
    },
    /**
     * Path da foto do usuário
     */
    pathFoto: {
      type: String
    },
    /**
     * Path do Logo
     */
    pathLogo: {
      type: String
    },
    /**
     * Path do Logo
     */
    linkLogo: {
      type: String
    },
    /**
     * Exibe o icone de engrenagem
     */
    exibeAcoes: {
      type: Boolean
    },
    /**
     * Itens do menu de açoes
     */
    menuAcoes: {
      type: Array
    }
  },
  data () {
    return {
      imageError: false
    }
  },
  computed:{
    data (){
      return moment(this.dataUltimoAcesso).format(this.$t('DATE_FORMAT'))
    }
  },
  methods: {
    onSair () {
      /**
       * Evento quando usuario clica no botao sair
       * @emits sair
       */
      this.$emit('sair')
    },
    onEditarPerfil () {
      /**
       * Evento quando usuario clica no botao editar perfil
       * @emits editar-perfil
       */
      this.$emit('editar-perfil')
    },
    imageLoadOnError(event) {
      this.imageError = true
    }
  }

};
</script>
